import { useEffect, useMemo, useState } from "react";
import { api } from "../../data";
import { igMediaPaths, igMediaResolver, type MediaUrlResolver, type ShareResponse } from "./insights-model";

/**
 * 0429: Bilder der Insights (privater Bucket ig-media) für angemeldete Personen: eigene Ansicht des Creators, Vorschau und
 * Teamansicht der Agentur. Alle Pfade einer Ansicht gehen in einer Anfrage an api.igMediaUrls (createSignedUrls mit der Anmeldung,
 * Storage-Policy: Mitglieder der Agentur und der Creator selbst); die Adressen gelten eine Stunde und liegen im Zwischenspeicher
 * der Api (signierte-adressen.ts), so dass ein erneutes Zeichnen oder Umschalten keine neue Anfrage auslöst. Ohne React Query,
 * damit die öffentliche Seite (Teamansicht unter /i/…) ohne QueryClient auskommt. Ohne Methode (Demo) oder ohne Rechte: keine
 * Bilder, Platzhalter.
 */
export function useIgMediaResolver(r: Pick<ShareResponse, "blocks" | "profile" | "top_posts"> | null | undefined): MediaUrlResolver {
  const key = igMediaPaths(r).join(",");
  const [urls, setUrls] = useState<{ key: string; map: Record<string, string> }>({ key: "", map: {} });
  useEffect(() => {
    const sign = api.igMediaUrls?.bind(api);
    if (!sign || !key) return;
    let alive = true;
    sign(key.split(","))
      .then((map) => { if (alive) setUrls({ key, map }); })
      .catch(() => { if (alive) setUrls({ key, map: {} }); });
    return () => { alive = false; };
  }, [key]);
  const map = urls.key === key ? urls.map : null;
  return useMemo(() => igMediaResolver(map), [map]);
}
